import { render } from "./Cards.vue?vue&type=template&id=21c728e3"
import script from "./Cards.vue?vue&type=script&lang=ts"
export * from "./Cards.vue?vue&type=script&lang=ts"
script.render = render

export default script